/*
 * Renders a group of checkboxes that can be used to select
 * multiple values from a set of options.
 *
 * The corresponding component when rendering the selected
 * values is PropertyGroup.
 *
 */

import React, { useState } from 'react';
import { arrayOf, bool, node, shape, string } from 'prop-types';
import classNames from 'classnames';
import { FieldArray } from 'react-final-form-arrays';
import { FieldCheckbox, FieldTextInput, ValidationError } from '../../components';
import { ReactComponent as Delete } from '../../assets/svg/Delete.svg';
import css from './FieldCheckboxGroup.module.css';
import { FormattedMessage } from 'react-intl';
import { composeValidators, required } from '../../util/validators';
const textfield = 'textfield';
const errorTextField = 'errorTextField';
const FieldCheckboxRenderer = props => {
  const {
    className,
    rootClassName,
    label,
    twoColumns,
    id,
    fields,
    options,
    meta,
    selectedClassName,
    selectedValuesArray = [],
    userNativeLang,
    showTooltip,
    form,
    values,
    descriptionRequiredMessage,
    decsPlaceholderText,
    intervalType,
    fromEditListing,
    handleDelete,
    onChange: propsOnChange,
    // handleEdit,
  } = props;
  const classes = classNames(rootClassName || css.root, className);
  const listClasses = twoColumns ? classNames(css.list, css.twoColumns) : css.list;
  const [editMode, seteditMode] = useState(false);

  const onChangePropsMaybe = typeof propsOnChange === 'function' ? { onChange: propsOnChange } : {};

  return (
    <fieldset className={classes}>
      {label ? <legend>{label}</legend> : null}
      <ul className={listClasses}>
        {options.map((option, index) => {
          const fieldId = `${id}.${option.key}`;
          return (
            <li
              key={fieldId}
              className={classNames(css.item, {
                [selectedClassName]: selectedValuesArray?.includes(option.key),
              })}
            >
              {}{' '}
              {!!option?.desc ? (
                <>
                  <FieldCheckbox
                    id={`${fieldId}[${index}].checkbox`}
                    // name={`${fieldId}[${index}].checkbox`}
                    // id={fieldId}
                    name={fields.name}
                    // label={option.label}
                    label={
                      typeof option.label === 'string' ? option.label : option.label[userNativeLang]
                    }
                    value={option.key}
                    tooltipDesc={
                      !!option?.desc && typeof option?.desc === 'string'
                        ? option?.desc
                        : option?.desc[userNativeLang]
                    }
                    showTooltip={showTooltip}
                    onChange={e => {
                      // console.log(
                      //   741,
                      //   e,
                      //   (values.riskFactors || [])?.includes(e.length > 0 ? option.key : 'qwerty')
                      // );
                      form.change(
                        'riskFactors',
                        e.length > 0
                          ? (values.riskFactors || [])?.includes(
                              e.length > 0 ? option.key : 'qwerty'
                            )
                            ? values.riskFactors?.filter(d => d !== option.key)
                            : [...(values.riskFactors || []), option.key]
                          : values.riskFactors?.filter(d => d !== option.key)
                      );
                      form.change(
                        'RiskFactorDesc',

                        e.length > 0
                          ? (values.riskFactors || [])?.includes(
                              e.length > 0 ? option.key : 'qwerty'
                            )
                            ? [values.RiskFactorDesc?.filter(f => f?.key !== option.key)]
                            : [
                                ...(values.RiskFactorDesc?.filter(f => f?.key !== option.key) ||
                                  []),
                                { key: `${option.key}`, value: '' },
                              ]
                          : values.RiskFactorDesc?.filter(d => d?.key !== option.key)
                        // e.includes(option.key)
                        //   ? [
                        //       ...(values.RiskFactorDesc?.filter(f => f?.key !== option.key) || []),
                        //       { key: `${option.key}`, value: '' },
                        //     ]
                        //   : [values.RiskFactorDesc?.filter(f => f?.key !== option.key)]
                      );
                    }}
                  />
                  {/* {console.log(656, decsPlaceholderText)} */}
                  {selectedValuesArray?.includes(option.key) ? (
                    <div className={css.safetyDiv}>
                      <label>
                        <FormattedMessage id="EditListingHealthForm.riskDescLabel" />
                      </label>
                      <input
                        className={css.textfield}
                        id={`${fieldId}[${index}].description`}
                        name={`${fieldId}[${index}].description`}
                        // id={fieldId}
                        // name={fields.name}
                        type="text"
                        value={values?.RiskFactorDesc?.find(f => f.key === option.key)?.value}
                        placeholder={decsPlaceholderText}
                        // validate={composeValidators(required(descriptionRequiredMessage))}
                        onChange={val => {
                          form.change('RiskFactorDesc', [
                            ...(values.RiskFactorDesc?.filter(f => f.key !== option.key) || []),
                            { key: `${option.key}`, value: val.target.value },
                          ]);
                          // console.log(555, val)
                        }}
                        // onBlur={val => {
                        //   const isEmpty = !val.target.value;
                        //   console.log(885, isEmpty, showRequiredMsg);

                        //   if (isEmpty === 'true') {
                        //     setShowRequiredMsg(true);
                        //   }
                        // }}
                      />
                      {/* {showRequiredMsg ? <div>sdfgh</div> : null} */}
                    </div>
                  ) : null}
                </>
              ) : (
                <>
                  <div className={css.EditCheckbox}>
                    <FieldCheckbox
                      id={fieldId}
                      name={fields.name}
                      // label={option.label}
                      intervalType={intervalType}
                      disabled={intervalType === 'Daily' ? true : false}
                      label={
                        typeof option.label === 'string'
                          ? option.label
                          : option.label[userNativeLang]
                      }
                      value={option.key}
                      {...onChangePropsMaybe}
                    />
                    {fromEditListing && options.length > 5 && index > 4 ? (
                      <div className={css.EditDeltWrapper}>
                        {/* <div
                          className={css.editOrDelt}
                          onClick={() => handleEdit({ index, fields, fieldId })}
                        >
                          Edit
                        </div> */}
                        <div
                          className={css.editOrDelt}
                          onClick={() => handleDelete({ form, option, fieldId })}
                        >
                          <div className={css.DeltWrap}>
                            <Delete className={css.DelIcon} />
                            <FormattedMessage id="EditListingInstructionForm.Delete" />
                          </div>
                        </div>
                      </div>
                    ) : null}
                  </div>
                </>
              )}
            </li>
          );
        })}
      </ul>
      <ValidationError fieldMeta={{ ...meta }} />
    </fieldset>
  );
};

FieldCheckboxRenderer.defaultProps = {
  rootClassName: null,
  className: null,
  label: null,
  twoColumns: false,
};

FieldCheckboxRenderer.propTypes = {
  rootClassName: string,
  className: string,
  id: string.isRequired,
  label: node,
  options: arrayOf(
    shape({
      key: string.isRequired,
      label: node.isRequired,
    })
  ).isRequired,
  twoColumns: bool,
};

const FieldCheckboxGroup = props => <FieldArray component={FieldCheckboxRenderer} {...props} />;

// Name and component are required fields for FieldArray.
// Component-prop we define in this file, name needs to be passed in
FieldCheckboxGroup.propTypes = {
  name: string.isRequired,
};

export default FieldCheckboxGroup;
